"use client";

import { useLanguage } from "@/i18n/LanguageContext";

export default function BottomCta() {
  const { t } = useLanguage();

  return (
    <section className="bg-[#064e3b] py-20 px-4 md:px-6 text-center">
      <div className="max-w-4xl mx-auto">
        <h2 className="text-2xl md:text-[36px] font-bold text-white mb-4">
          {t("sliding.bottomCtaH2")}
        </h2>
        <p className="text-[#fefce8] max-w-[720px] mx-auto mb-8 text-base">
          {t("sliding.bottomCtaSub")}
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="tel:+17863774452"
            className="inline-flex items-center justify-center gap-2 px-6 py-3 bg-[#ea580c] hover:bg-[#ea580c]/90 text-white font-semibold rounded-md transition-colors whitespace-nowrap"
          >
            <i className="ri-phone-line" />
            {t("sliding.bottomCtaCallBtn")}
          </a>
          <a
            href="mailto:contact@impact-window-repair-miami.com"
            className="inline-flex items-center justify-center px-6 py-3 border-2 border-white text-white font-semibold rounded-md hover:bg-white hover:text-[#064e3b] transition-colors whitespace-nowrap"
          >
            {t("sliding.bottomCtaEmailBtn")}
          </a>
        </div>
      </div>
    </section>
  );
}